import { useState } from 'react'
import SidePage from '@/shared/SidePage'
import { IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'
import ViewUnitInstanceSidePageContent from '@/pages/MDM/components/Units/UnitInstanceSidePage/ViewUnitInstanceSidePageContent'
import EditUnitInstanceSidePageContent from '@/pages/MDM/components/Units/UnitInstanceSidePage/EditUnitInstanceSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  instance: IMDMUnitInstance
  onCloseAnimationEnd?: () => void
}

const UnitInstanceSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    switch (pageMode) {
      case 'view':
        return (
          <ViewUnitInstanceSidePageContent
            instance={props.instance}
            onClose={props.onClose}
            onEdit={() => setPageMode('edit')}
          />
        )
      case 'edit':
        return <EditUnitInstanceSidePageContent onClose={() => setPageMode('view')} instance={props.instance} />
    }
  }

  return (
    <SidePage
      onClose={props.onClose}
      open={props.open}
      style={{ paddingBottom: 0 }}
      onCloseAnimationEnd={props.onCloseAnimationEnd}
    >
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.instance) return null

  return <UnitInstanceSidePage {...props} />
}
